module.exports = __webpack_public_path__ + "img/source-stop.458e3745.png";